import React, { memo } from "react";
import styled from "styled-components";
import scrollbar from "../../../helpers/scrollbar";
import { negativeColor } from "../../../helpers/color";
import { secondaryBackground } from "../../../helpers/background";
import Button from "../../Inputs/Button";
import Panel from "../Panel";
import Divider from "../Divider";
const Root = /*#__PURE__*/styled(Panel).withConfig({
  displayName: "Root",
  componentId: "sc-1y0csub-0"
})(["overflow:hidden;height:100%;"]);
const Bar = /*#__PURE__*/styled.div.withConfig({
  displayName: "Bar",
  componentId: "sc-1y0csub-1"
})(["display:flex;align-items:center;justify-content:center;padding:8px;"]);
const Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-1y0csub-2"
})(["", " ", " flex:1;"], scrollbar, secondaryBackground);
const Alert = /*#__PURE__*/styled.div.withConfig({
  displayName: "Alert",
  componentId: "sc-1y0csub-3"
})(["position:absolute;top:5px;right:5px;padding:0 4px;min-width:15px;border-radius:10px;background-color:", ";color:white;font-size:10px;font-weight:700;line-height:15px;text-align:center;"], negativeColor);

// const Toggle = styled.div`
// 	${defaultBackground}

// 	position: absolute;
// 	top: 17px;
// 	right: -18px;
// 	width: 23px;
// 	height: 23px;
// 	border-radius: 10px;
// 	border: 2px solid ${dividerColor};
// `;

const Tabs = /*#__PURE__*/memo(({
  index,
  children,
  onChange,
  ...props
}) => {
  const array = React.Children.toArray(children);
  const current = array[index] ? array[index].props : {};
  return /*#__PURE__*/React.createElement(Root, props, /*#__PURE__*/React.createElement(Bar, null, array.map(({
    props: {
      Icon,
      alert
    }
  }, i) => /*#__PURE__*/React.createElement(Button, {
    key: i,
    transparent: true,
    color: "primary",
    active: i === index,
    onClick: () => onChange(i)
  }, Icon, alert ? /*#__PURE__*/React.createElement(Alert, null, alert === true ? "!" : alert) : false))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Content, current));
});
Tabs.Tab = () => {};
export default Tabs;
//# sourceMappingURL=index.js.map